import React, { useEffect, useRef, useState } from "react";
import { Eye } from "lucide-react";

const WhySection = () => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            let start = 0;
            const target = 44;
            const duration = 1400;
            const startTime = performance.now();
            const tick = (now) => {
              const p = Math.min((now - startTime) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setCount(Math.round(eased * target));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="py-24 md:py-36 bg-neutral-950 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.18),rgba(249,115,22,0.12)_30%,transparent_60%)]" />
      </div>

      <div className="max-w-[1100px] mx-auto px-6 md:px-10 relative">
        <div className="flex items-center gap-2 mb-8">
          <Eye size={16} className="text-pink-400" />
          <span className="text-xs uppercase tracking-[0.3em] font-semibold text-neutral-400">
            Warum Social Media?
          </span>
        </div>

        <div className="flex flex-col md:flex-row md:items-end gap-8 md:gap-12">
          <div className="font-display font-extrabold text-[120px] md:text-[200px] lg:text-[260px] leading-[0.85] tracking-[-0.05em] bg-gradient-to-br from-pink-400 via-orange-400 to-purple-400 bg-clip-text text-transparent">
            {count}%
          </div>
          <div className="max-w-md md:pb-8">
            <p className="font-display font-extrabold text-2xl md:text-3xl tracking-tight leading-tight">
              des Tages verbringen Menschen auf Social Media.
            </p>
          </div>
        </div>

        <div className="mt-12 max-w-3xl">
          <p className="text-lg md:text-xl text-neutral-300 leading-relaxed">
            Eure Zielgruppe ist bereits dort – die Frage ist nur:{" "}
            <span className="text-white font-semibold">Seid ihr sichtbar?</span>
          </p>
          <p className="mt-4 text-lg text-neutral-400 leading-relaxed">
            Viele posten bereits, aber die Herausforderung ist: aus der Masse
            herausstechen. Genau da kommen wir ins Spiel.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
